// extracted by mini-css-extract-plugin
export default {"link-color":"News_link-color__wRuct","pointer":"News_pointer__203sh","newsText":"News_newsText__G6Prf","newsItem":"News_newsItem__UL5KN"};